import { Button } from "@mui/material";
import { useState } from "react";
import OperatingSystemsManagementDialog from "./OperatingSystemsManagementDialog";

const OperatingSystemsManagementButton = () => {
  const [typeDialogOpen, setTypeDialogOpen] = useState<boolean>(false);
  const openTypeDialog = () => {
    setTypeDialogOpen(true);
  };
  return (
    <>
      <Button onClick={openTypeDialog} variant="outlined">
        Manage Operating Systems
      </Button>
      <OperatingSystemsManagementDialog
        dialogOpen={typeDialogOpen}
        setDialogOpen={setTypeDialogOpen}
      />
    </>
  );
};

export default OperatingSystemsManagementButton;
